var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 10,
    viewBox: "0 0 5 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3626e-05 4.62669C-0.000620085 4.505 0.020387 4.38438 0.0618289 4.27173C0.103271 4.15909 0.164333 4.05663 0.241515 3.97023L3.57257 0.271911C3.65021 0.185705 3.74239 0.117322 3.84384 0.0706677C3.94529 0.0240131 4.05402 -3.95333e-08 4.16383 -3.65502e-08C4.27364 -3.3567e-08 4.38237 0.0240131 4.48382 0.0706677C4.58527 0.117322 4.67745 0.185705 4.75509 0.271911C4.83274 0.358118 4.89433 0.46046 4.93635 0.573094C4.97837 0.685729 5 0.806449 5 0.928364C5 1.05028 4.97837 1.171 4.93635 1.28363C4.89433 1.39627 4.83274 1.49861 4.75509 1.58482L1.99864 4.62669L4.64683 7.6778C4.73202 7.76286 4.80048 7.86651 4.84793 7.98228C4.89539 8.09805 4.92082 8.22344 4.92263 8.35062C4.92445 8.4778 4.90261 8.60403 4.85848 8.72141C4.81435 8.83879 4.74888 8.9448 4.66617 9.0328C4.58345 9.12081 4.48527 9.18892 4.37777 9.23288C4.27026 9.27684 4.15575 9.2957 4.04138 9.28827C3.92701 9.28085 3.81525 9.24731 3.71309 9.18974C3.61093 9.13218 3.52057 9.05183 3.44765 8.95372L0.233187 5.2554C0.0863583 5.08632 0.00299146 4.86153 1.3626e-05 4.62669Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.30274d2b939be35f5e01fc65cd094269.svg";
export { ForwardRef as ReactComponent };